<ng-container *transloco="let t">
  <div id="under-maintenance-page" class="min-h-screen flex flex-col bg-ld-neutral-50">
    <header id="under-maintenance-header" class="bg-white w-full flex flex-col shrink-0 shadow-card">
      <div class="w-full h-[64px] flex items-center justify-center border-b border-ld-border">
        <div class="max-w-[1440px] w-full h-full flex items-center px-8 max-sm:px-4">
          <div id="under-maintenance-logo" class="w-[184px] h-10 flex items-center shrink-0 max-sm:w-[140px]">
            <img [src]="logo" alt="loanDepot" class="w-full h-full object-contain object-left" />
          </div>
        </div>
      </div>
    </header>

    <main id="under-maintenance-content" class="flex-1 flex flex-col items-center justify-center px-4 py-8">
      <img
        id="under-maintenance-image"
        [src]="maintenanceImage"
        [alt]="t('underMaintenanceImageAlt')"
        class="max-w-xl w-full h-auto mb-8 max-sm:max-w-xs"
      />

      <h1
        id="under-maintenance-title"
        class="font-dm text-4xl font-bold text-ld-neutral mb-4 text-center max-sm:text-2xl"
      >
        {{ t('underMaintenanceTitle') }}
      </h1>

      <p
        id="under-maintenance-subtitle"
        class="font-dm text-lg text-ld-neutral-500 text-center max-w-xl max-sm:text-base"
      >
        {{ message() || t('underMaintenanceDefaultMessage') }}
      </p>
    </main>

    <footer
      id="under-maintenance-footer"
      class="bg-ld-neutral-50 border-t border-ld-border py-4 px-8 w-full shrink-0 max-sm:px-4"
    >
      <div class="max-w-[1440px] mx-auto flex flex-col gap-2">
        <div class="flex flex-wrap items-center justify-between gap-4 max-sm:flex-col max-sm:items-start max-sm:gap-2">
          <p id="under-maintenance-footer-nmls" class="font-general text-xs leading-[18px] text-ld-neutral-500 m-0">
            NMLS#{{ nmlsId }} -
            <a
              id="under-maintenance-footer-nmls-link"
              [href]="nmlsConsumerAccessUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="font-bold text-black underline hover:text-ld-neutral-700"
            >
              NMLS Consumer Access Site
            </a>
            | 6561 Irvine Center Drive. Irvine, CA 92618
          </p>
          <img
            id="under-maintenance-footer-eho"
            [src]="equalHousingLogo"
            [alt]="t('footerEqualHousingAlt')"
            class="block w-9 h-9 object-contain shrink-0"
          />
        </div>
        <p class="font-general text-xs leading-[18px] text-ld-neutral-500 m-0">
          {{ t('underMaintenanceCopyright', { year: currentYear }) }}
        </p>
        <p class="font-general text-xs leading-[18px] text-ld-neutral-500 m-0">
          {{ t('underMaintenanceTermsPrefix') }}
          <a
            id="under-maintenance-footer-privacy"
            [href]="privacyUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="text-ld-link underline hover:text-ld-neutral-700"
          >
            {{ t('underMaintenancePrivacyPolicy') }}
          </a>
          {{ t('commonAnd') }}
          <a
            id="under-maintenance-footer-terms"
            [href]="termsOfUseUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="text-ld-link underline hover:text-ld-neutral-700"
          >
            {{ t('commonLinksTermsOfUse') }}
          </a>
          .
        </p>
      </div>
    </footer>
  </div>
</ng-container>
